import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../../../vue";
import { arrayRemove } from "../../../../tools/lang";
import { IMethodEditorState } from "../../MethodEditorState";
import styles from "./style.module.css";
let MethodParams = class MethodParams extends Vue {
  addParam() {
    this.formInfo.args.push({
      id: '',
      title: ''
    });
  }
  remove(item) {
    arrayRemove(this.formInfo.args, item);
  }
  render() {
    const h = arguments[0];
    // const addText = '添加自定义参数';
    return h("div", {
      "class": styles.methodParams
    }, [this.formInfo.args.map(arg => {
      const disabled = arg['ds:systemArg'];
      return h("div", {
        "class": [styles.formItem]
      }, [h("a-input", {
        "attrs": {
          "addon-before": "args.",
          "placeholder": "参数id",
          "disabled": disabled
        },
        "class": styles.input,
        "model": {
          value: arg.id,
          callback: $$v => {
            this.$set(arg, "id", $$v);
          }
        }
      }, [h("a-tooltip", {
        "slot": "suffix",
        "attrs": {
          "title": `在方法js中通过 args.${arg.id} 进行访问`
        }
      }, [h("a-icon", {
        "attrs": {
          "type": "info-circle"
        },
        "style": "color: rgba(0,0,0,.45)"
      })])]), h("a-input", {
        "class": styles.input,
        "attrs": {
          "placeholder": "参数标题",
          "disabled": disabled
        },
        "model": {
          value: arg.title,
          callback: $$v => {
            this.$set(arg, "title", $$v);
          }
        }
      })]);
    })]);
  }
};
__decorate([IMethodEditorState], MethodParams.prototype, "state", void 0);
__decorate([Prop()], MethodParams.prototype, "formInfo", void 0);
MethodParams = __decorate([Component({
  name: 'MethodParams'
})], MethodParams);
export default MethodParams;
//# sourceMappingURL=MethodParams.js.map
